import CarContactForm from './car-contact-form';

function init() {
  CarContactForm.init();
}

export { init };
